import { createContext, useContext } from 'react';

import type { LoginRequest } from './provider';
import type { SessionSnapshot } from './session';

export type SessionContextValue = SessionSnapshot & {
  readonly login: (input: LoginRequest) => Promise<void>;
  readonly logout: () => Promise<void>;
  readonly retry: () => Promise<void>;
};

export const SessionContext = createContext<SessionContextValue | null>(null);

export function useSession(): SessionContextValue {
  const session = useContext(SessionContext);
  if (!session) {
    throw new Error('useSession must be used within SessionProvider');
  }
  return session;
}
